<div class="raci-steps-wrapper" *ngIf="activePortfolio">
  <div *ngFor="let step of steps">
    <div class="raci-step-block">
      <div class="raci-step-block-content">
        <div class="raci-step-icon raci-step-icon-orange">
          <svg-icon *ngIf="step?.actionStageId != actionStage.Waiting"
                    src='./assets/icons/checkmark.svg'
                    (click)="updateStepActionStage(step)"
                    alt="STEP"
                    class="raci-icon"
                    [ngClass]="checkIfStepIsCompleted(step) ? 'raci-step-icon-done' : 'svg-icon-new' "
                    align='center'>
          </svg-icon>
          <svg-icon *ngIf="step?.actionStageId == actionStage.Waiting"
                    src='./assets/icons/circle-half-stroke-solid.svg'
                    (click)="updateStepActionStage(step)"
                    alt="IN PROGRESS"
                    class="raci-icon svg-icon-in-progress"
                    align='center'>
          </svg-icon>
        </div>
        <div class="raci-step-title"
             (click)="toggleStep(step) "
             [ngClass]="activeStep?.projectStepId == step?.projectStepId ? 'active-card': ''">
          <p class="hidden-text">
            {{step?.stepOrderNumber}}&nbsp;|&nbsp;
            </p>
          <p class="hidden-text" >
            {{step?.stepName?.toUpperCase()}}
            <span class="tooltip" *ngIf="step?.stepName?.length > 30">
            {{step?.stepName?.toUpperCase()}}
            </span>
          </p>
        </div>
      </div>
      <div class="toogle" *ngIf="step?.tasks?.length > 0">
        <svg-icon src='./assets/icons/chevron-down-outline.svg'
                  class="raci-icon icon-toogle"
                  [ngClass]="activeStep?.projectStepId == step?.projectStepId? 'icon-toogle-rotate' : '' "
                  title="{{'raci.raciStepsPane.valuationPortfolio' | translate}}"
                  (click)="expandStep($event, step)">
        </svg-icon>
      </div>
    </div>
    <div *ngIf="activeStep && activeStep == step && activeStep?.tasks?.length > 0"
         class="raci-step-substeps">
      <div *ngFor="let task of activeStep?.tasks"
           class="raci-substep-block">
        <div class="raci-substep-icon">
          <svg-icon *ngIf="!task?.isCompleted && task?.taskActionStage != actionStage.Waiting"
                    (click)="updateTaskActionStage(task)"
                    src='./assets/icons/users.svg'
                    alt="NEW"
                    class="raci-icon svg-icon-new"
                    align='center'>
          </svg-icon>
          <svg-icon *ngIf="!task?.isCompleted && task?.taskActionStage == actionStage.Waiting"
                    (click)="updateTaskActionStage(task)"
                    src='./assets/icons/circle-half-stroke-solid.svg'
                    alt="IN PROGRESS"
                    class="raci-icon svg-icon-in-progress"
                    align='center'>
          </svg-icon>
          <svg-icon *ngIf="task?.isCompleted && task?.taskActionStage != actionStage.Waiting"
                    src='./assets/icons/checkmark.svg'
                    alt="COMPLETED"
                    class="raci-icon raci-step-icon-done"
                    align='center'>
          </svg-icon>
        </div>
        <h3 class="raci-substep-title"
            [ngClass]="activeTask?.projectTaskId == task.projectTaskId ? 'active-card': ''"
            (click)="setActiveTask(task) && updateHistoryIconVisibility()">
          {{activeStep?.stepOrderNumber}}.{{task?.taskOrderNumber}} | {{task?.taskName}}
        </h3>
      </div>
    </div>
  </div>
</div>
